import { useRouter } from 'next/router'
import { getSingleTspType, TspType, useCyberStore } from '@entities/tsp'
import {
  gamesNavbarItem,
  keysNavbarItem,
  mainNavbarItem,
  newsNavbarItem,
  servicesNavbarItem,
  steamNavbarItem,
} from '../config/navbarItems'

export const useActiveNavbarElement = () => {
  const router = useRouter()

  const { activeService } = useCyberStore()

  if (router.pathname === '/') {
    return mainNavbarItem
  }

  if (router.pathname === '/steam') {
    return steamNavbarItem
  }

  if (router.pathname === '/games') {
    return gamesNavbarItem
  }

  if (router.pathname === '/keys') {
    return keysNavbarItem
  }

  if (router.pathname === '/services') {
    return servicesNavbarItem
  }

  if (router.pathname === '/news') {
    return newsNavbarItem
  }

  if (router.pathname === '/[id]' && activeService) {
    if (getSingleTspType(activeService) === TspType.GAMES) {
      return gamesNavbarItem
    }
    if (getSingleTspType(activeService) === TspType.SERVICES) {
      return servicesNavbarItem
    }
    if (getSingleTspType(activeService) === TspType.KEYS) {
      return keysNavbarItem
    }
  }
}
